import React from 'react';
import { StarsProps } from './types';

function Stars({ rating, numberOfReviews }: StarsProps) {
  const stars = Array.from(Array(5).keys());
  const starFill = (rating: number, index: number) => {
    const starValue = Number((rating - index).toFixed(2));

    if (starValue >= 0.8) {
      return 'rating-star--filled';
    }

    if (starValue >= 0.3) {
      return 'rating-star--half-filled';
    }

    return '';
  };

  return (
    <div className="rating-stars">
      <div className="rating-stars__stars">
        {stars.map(index => (
          <div
            key={index}
            className={`rating-star ${starFill(rating, index)}`}
          ></div>
        ))}
      </div>
      <span className="rating-stars__average">{rating}</span>
      <span className="rating-stars__total">({numberOfReviews})</span>
    </div>
  );
}
export default Stars;
